// All analytics related apis
import { BASEURL } from "./api";
import instance from "./api";
import { encryptData } from "../helpers/encryptDecrypt";
const API_URL = BASEURL + "/api/analytics";

// Api for fetching Organization's revenue analytics data based on selected branch, start_date, end_date or filter
export const fetchRevenueAnalytics = async (
  organization_id,
  branch_id,
  filter_type,
  start_date,
  end_date
) => {
  const oId = encryptData(organization_id);
  const bId = branch_id === "none" ? "" : encryptData(branch_id);
  return await instance.get(
    `${API_URL}/revenue?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&start_date=${start_date}&end_date=${end_date}`
  );
};

// Api for fetching Organization's sales analytics data based on selected branch, start_date, end_date or filter
export const fetchSalesAnalytics = async (
  organization_id,
  branch_id,
  filter_type,
  start_date,
  end_date
) => {
  const oId = encryptData(organization_id);
  const bId = branch_id === "none" ? "" : encryptData(branch_id);
  return await instance.get(
    `${API_URL}/sales?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&start_date=${start_date}&end_date=${end_date}`
  );
};

// Api for fetching Organization's products analytics data based on selected branch, start_date, end_date or filter
export const fetchProductsAnalytics = async (
  organization_id,
  branch_id,
  filter_type,
  start_date,
  end_date
) => {
  const oId = encryptData(organization_id);
  const bId = branch_id === "none" ? "" : encryptData(branch_id);
  return await instance.get(
    `${API_URL}/products?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&start_date=${start_date}&end_date=${end_date}`
  );
};

// Api for fetching Organization's categories analytics data based on selected branch, start_date, end_date or filter
export const fetchProductCategoriesAnalytics = async (
  organization_id,
  branch_id,
  filter_type,
  start_date,
  end_date
) => {
  const oId = encryptData(organization_id);
  const bId = branch_id === "none" ? "" : encryptData(branch_id);
  return await instance.get(
    `${API_URL}/categories?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&start_date=${start_date}&end_date=${end_date}`
  );
};

// Api for fetching Organization's payment-methods analytics data based on selected branch, start_date, end_date or filter
export const fetchPaymentMethodsAnalytics = async (
  organization_id,
  branch_id,
  filter_type,
  start_date,
  end_date
) => {
  const oId = encryptData(organization_id);
  const bId = branch_id === "none" ? "" : encryptData(branch_id);
  return await instance.get(
    `${API_URL}/payment-methods?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&start_date=${start_date}&end_date=${end_date}`
  );
};

// Api for fetching Organization's branches analytics data based on selected branch, start_date, end_date or filter
export const fetchBranchAnalytics = async (
  organization_id,
  filter_type,
  start_date,
  end_date
) => {
  const oId = encryptData(organization_id);
  return await instance.get(
    `${API_URL}/branches?organizationId=${oId}&filter_type=${filter_type}&start_date=${start_date}&end_date=${end_date}`
  );
};

// Api for fetching Organization's staffs/users analytics data based on selected branch, start_date, end_date or filter
export const fetchStaffAnalytics = async (
  organization_id,
  branch_id,
  filter_type,
  start_date,
  end_date
) => {
  const oId = encryptData(organization_id);
  const bId = branch_id === "none" ? "" : encryptData(branch_id);
  return await instance.get(
    `${API_URL}/staffs?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&start_date=${start_date}&end_date=${end_date}`
  );
};

// Api for fetching Organization's customers analytics data based on selected branch, start_date, end_date or filter
export const fetchCustomerAnalytics = async (
  organization_id,
  branch_id,
  filter_type,
  start_date,
  end_date
) => {
  const oId = encryptData(organization_id);
  const bId = branch_id === "none" ? "" : encryptData(branch_id);
  return await instance.get(
    `${API_URL}/customers?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&start_date=${start_date}&end_date=${end_date}`
  );
};
